import { render, staticRenderFns } from "./app-context-menu.vue?vue&type=template&id=07a70afa&scoped=true"
import script from "./app-context-menu.vue?vue&type=script&lang=ts"
export * from "./app-context-menu.vue?vue&type=script&lang=ts"
import style0 from "./app-context-menu.vue?vue&type=style&index=0&id=07a70afa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a70afa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a70afa')) {
      api.createRecord('07a70afa', component.options)
    } else {
      api.reload('07a70afa', component.options)
    }
    module.hot.accept("./app-context-menu.vue?vue&type=template&id=07a70afa&scoped=true", function () {
      api.rerender('07a70afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/partials/app-context-menu.vue"
export default component.exports